import React,{useState} from 'react'
import { Row, Col, Input } from 'antd'
import { backgroundColor1, buttonColor1, buttonColor2, dailyinsColor, footerColor } from '../const';
import { isxl, isMD, isMobile } from '../helpers/config';
const HeroSection = (props) => {
    const [number, setNumber] = useState("");
    const [isActive, setIsActive] = useState(false);

    const checkPhoneNumber = (item) => {
        let isnum = /^\d+$/.test(item);
        if(item.length === 10 && isnum){
            setIsActive(true);
        }else{
            setIsActive(false);
        }
        setNumber(item);
    }
   
    const cssStyle = {
        container : {
            display:'flex',
            flexDirection:'column',
            padding: isMobile(props.width)? '32px 20px': isxl(props.width)?'32px 100px': props.width>1400 ? '32px 124px' : props.width>1400 ? '32px 160px' : '32px 48px',
            backgroundColor: backgroundColor1,
        },
        logo:{
            marginTop:'12px',
            height:'32px',
            width:'108px',
        },
        logo2:{
            height:'32px',
            width:'32px',
        },
        lend:{
            width: isMobile(props.width)?'260px': isMD(props.width)? '320px' : props.width<1100?'440px': '546px',
            height: isMobile(props.width)?'260px':  isMD(props.width)? '320px' :props.width<1100?'440px':'546px',
        },
        companyName:{
            fontFamily: 'Aref Ruqaa Ink',
            fontSize: '20px',
            fontWeight: '700',
            lineHeight: '31px',
            letterSpacing: "0em",
        },
        hero : {
            display:'flex',
            flexDirection: props.width<768 ? 'column' : 'row',
            justifyContent:'space-between',
            alignItems:"center",
        },
        heroLeft:{
            fontFamily: 'Plus Jakarta Sans',
            fontSize: isMobile(props.width)?'20px': isMD(props.width)?'24px': '32px',
            fontWeight: '400',
            lineHeight: isMobile(props.width)?'30px':isMD(props.width)?'36px':'48px',
            letterSpacing: "0em",
        },
        heroLeftBold:{
            fontWeight: '700',
        },
        heroLeft2:{
            fontFamily: 'Plus Jakarta Sans',
            fontSize: isMD(props.width)?'14.5px': '16px',
            fontWeight: '500',
            lineHeight: isMD(props.width)?'18px': '24px',
            letterSpacing: "0em",
            color:'rgba(29, 29, 29, 0.7)',
        },
        heroLeft3:{
            fontFamily: 'Plus Jakarta Sans',
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '24px',
            letterSpacing: "0em",
            color: dailyinsColor
        },
        input : { borderRadius:'16px', height:isMobile(props.width)?'52px': '56px', padding:'16px', width: isMobile(props.width)?'160px': isMD(props.width)?'180px': '260px', fontSize: isMobile(props.width)?'10px': isMD(props.width)?'12px': '16px', },
        applyButton:{
            padding: isMobile(props.width)?'1px 16px':isMD(props.width)?'12px 16px':'16px 20px',
            fontFamily: 'Plus Jakarta Sans',
            fontSize: isMobile(props.width)?'12px': isMD(props.width)?'14px': '16px',
            fontWeight: '700',
            borderRadius:'16px',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            lineHeight: isMD(props.width)?'20px': '24px',
            letterSpacing: "0em",
            color:'white',
            backgroundColor: isActive? footerColor : buttonColor1,
            boxShadow:`4px 4px 0px ${buttonColor2}`,
            cursor:'pointer'
        },
        logoContainer:{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'flex-start',
        }
    };
  return (
    <Col style={cssStyle.container}>
        <Row style={cssStyle.logoContainer}>
            <img src='/images/dailypay_square.svg' alt='logo' style={cssStyle.logo2}/>
            <div style={{width:'8px'}}/>
            <img src='/images/DailyPe.png' alt='logo' style={cssStyle.logo}/>
            
            {/* <div style={cssStyle.companyName}>FinX</div> */}
        </Row>
        {props.width<992 && <div style={{height:props.width<768? '60px':'32px'}}/>  }
        <Row style={cssStyle.hero}>
            <Col>
                <div style={cssStyle.heroLeft}>
                    Get daily business loan from<br/><span style={cssStyle.heroLeftBold}>₹2K</span> to <span style={cssStyle.heroLeftBold}>₹2L</span> in minutes!!
                </div>
                <div style={{height:'16px'}}/>
                <div style={cssStyle.heroLeft2}>
                    Hate paying huge monthly installments,<br/>no worries pay small amounts daily.
                </div>
                <div style={{height:'16px'}}/>
                <div style={cssStyle.heroLeft3}>What is daily installment loan?</div>
                <div style={{height:'32px'}}/>
                <Row>
                    <Input style={cssStyle.input} size="large" placeholder="Enter your phone number" 
                        onChange={(e)=>{
                            e.preventDefault();
                            checkPhoneNumber(e.target.value);
                        }}
                    />
                    <div style={{width:'12px'}}/>
                    <div onClick={ isActive? ()=>{
                      props.notify(number);
                      setIsActive(false);
                    }:null} style={cssStyle.applyButton}>Apply Now</div>
                </Row>
            </Col>
            {props.width<768 && <div style={{height:'60px'}}/>  }
            <Col>
            <img src='/images/lend.png' alt='logo' style={cssStyle.lend}/>
            </Col>
        </Row>
        <div style={{height:'32px'}}/>
    </Col>
  )
}

export default HeroSection